import React from "react";

import {
  Flex,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Button,
  Input,
  UnorderedList,
  ListItem,
  Box,
} from "@chakra-ui/react";

//components
import Logo from "../logo/Logo";
import NavItem from "./NavItem";

//Navbar Data
import NavbarData from "./NavbarData";
import { Link, NavLink } from "react-router-dom";

const Navbar = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  return (
    <Flex
      id="navbar"
      zIndex={100}
      w={"100%"}
      py={"3rem"}
      px={{ base: "2rem", "2sm": "5rem", lg: "15rem" }}
      alignItems={"center"}
      justifyContent="space-between"
      position="absolute"
    >
      <Flex justifyContent={"center"} alignItems={"center"}>
        <Logo />
      </Flex>
      <Flex display={{ base: "none", md: "flex" }}>
        {NavbarData.map((item, index) => {
          return <NavItem key={index} item={item} />;
        })}
      </Flex>
      <Flex
        flexDir={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        color={"white"}
        ref={btnRef}
        onClick={onOpen}
        display={{ base: "flex", md: "none" }}
      >
        <i
          className="fa-solid fa-bars"
          style={{ margin: "1rem 0", width: "50%", fontSize: "4rem" }}
        ></i>
      </Flex>
      <Drawer
        display={{ base: "flex", md: "none" }}
        size={"xl"}
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
        finalFocusRef={btnRef}
        fontSize={"4rem"}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton
            m={"3rem 3rem"}
            fontSize={"3rem"}
            color={"whiteAlpha.900"}
          />

          <DrawerBody bg={"#1A202C"} padding={"5rem 3rem"}>
            <UnorderedList
              color={"whiteAlpha.900"}
              listStyleType={"none"}
              fontSize={"2.7rem"}
              textTransform={"uppercase"}
            >
              {NavbarData.map((item, index) => {
                return (
                  <NavLink
                    onClick={onClose}
                    to={{ pathname: item.url }}
                    key={index}
                  >
                    <ListItem my={".75rem"}>{item.name}</ListItem>
                    <Box bg={"#EA0F0F"} h="3px" w={"5rem"} mb={"1rem"}></Box>

                    {item.subMenu
                      ? item.subMenu.map((el, index) => {
                          return (
                            <Link
                              onClick={onClose}
                              to={{ pathname: el.url }}
                              state={{ id: el.id }}
                              key={index}
                            >
                              <ListItem
                                ml={"1rem"}
                                fontSize={"1.8rem"}
                                my={".5rem"}
                                cursor={"pointer"}
                              >
                                {el.name}
                              </ListItem>
                            </Link>
                          );
                        })
                      : null}
                  </NavLink>
                );
              })}
            </UnorderedList>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
};

export default Navbar;
